export const testAttributes: { [key: string]: string } = {
    handType: "PAIR", // Enum of the hand type
    accountCurrency: "XCC",
    stake: "20.0",
    winAmount: "10.0",
    netResult: "10.0",  // Net result, can be positive or negative
    win: "true",  // Only included if this was a win
    lost: "true",  // Only included if this was a lost
    tournament: "true", // True if this is a tournament table
    screenname: "screenName",
    rake: "2.0", // the rake that this player contributed with
    winRatio: "10.0",// win amount divided by ante (big blind), 2 decimals.
    ante: "0.1", // Big blind (DEPRECATED, use betLevel instead)
    betLevel: "2", // Ante or big blind for blinds-based variants
    variant: "TEXAS_HOLDEM", // Poker variant, e.g. TEXAS_HOLDEM
    externalId: "123", // External Player Id, i.e. the operator's identifier of the player
    createdTimestamp: "" + new Date().getTime(), // timestamp in millis
    isRakePhase: "true", // If the hand reached a raking phase, e.g. for Holdem the flop
    playersInHand: "6", // Integer how many players were involved in the hand
    tableSize: "6", // Total number of seats at the table
    totalRake: "0.5", // Total rake sum for all players in the hand
    totalPotSize: "30.0", // Total pot sum in the hand
    tableId: "1", // internal table id
    tableExternalId: "table",  // external table id
    handId: "1", // hand id
    seated: "6",  // seated players count
    sessionId: "abc" // String formated session id. Not included if player is not connected.
}

export class RuleCalculator {

    SPLIT_SYMBOL_REGEXP: string = "(%s)";

    SPLIT_SYMBOLS = ["<=", ">=", "!=", "<", ">", "=", "&", "\\|"];

    split = "";

    constructor() {
        var sb = "";
        for (var i = 0; i < this.SPLIT_SYMBOLS.length; i++) {
            if (sb.length > 0) {
                sb += "|";
            }
            sb += this.symbol(this.SPLIT_SYMBOLS[i]);
        }
        this.split = sb;
    };

    matches(rule, attributes) {
        var match = true;
        var elements = this.splitRule(rule);

        var expressions = this.getNumberOfExpressions(elements.length);

        for (var i = 0; i < expressions; i++) {
            var expression = elements.slice(i * 4, i * 4 + 3);
            var result = this.getExpressionResult(attributes, expression);
            if (i > 0) {
                var op = elements[i * 4 - 1];
                match = this.checkOperand(op, match, result);
            } else {
                match = result;
            }

        }
        return match;
    };

    symbol(symbol) {
        return this.SPLIT_SYMBOL_REGEXP.replace("%s", symbol).replace("%s", symbol)

    };

    splitRule(rule) {
        rule = this.removeWhitespace(rule);
        var splits = rule.split(new RegExp(this.split));
        return this.mergeOperators(splits);
    };

    mergeOperators(splits) {
        var target = [];
        for (var i = 0; i < splits.length; i++) {
            if (typeof(splits[i]) == "undefined") {
                continue;
            }
            if (splits[i].match(/!|<|>/g)) {
                if (i + 1 < splits.length && splits[i + 1] == "=") {
                    target.push(splits[i] + splits[i + 1]);
                    i++;
                    continue;
                }
            }
            target.push(splits[i]);
        }
        return target;
    };

    /**
     * Removes whitespace from a string except for whitespaces within
     * ' character.  eg
     * test white space 'to remove' => testwhitespace'to remove'
     * @param rule
     * @return
     */
    removeWhitespace(rule) {
        return rule.replace(/\s+(?=([^']*'[^']*')*[^']*$)/g, "");
    };

    checkOperand(op, var1, var2) {
        if (op == "&") {
            return var1 && var2;
        } else if (op == "|") {
            return var1 || var2;
        } else {
            throw new Error("Invalid expression operator " + op + ", should be & or |");
        }
    };

    getExpressionResult(attributes, expression) {
        return this.checkOperation(expression, attributes);
    };

    getNumberOfExpressions(length) {
        var rem = (length - 3) % 4;
        if (rem != 0) {
            throw new Error("Expression does not have a valid number of elements");
        }
        return 1 + ((length - 3) / 4);
    };

    checkOperation(expression, attributes) {
        var match = true;

        var operand = expression[1];

        var val1 = expression[0];
        var val2 = expression[2];

        val1 = this.doSubstitutionIfApplicable(val1, attributes);
        val2 = this.doSubstitutionIfApplicable(val2, attributes);

        if (val1 == null || val2 == null) {
            return false;
        }

        if (this.isBothNumeric(val1, val2)) {
            match = this.evaluateNumericExpression(val1, operand, val2);
        } else {
            match = this.evaluateStringExpression(val1, operand, val2);
        }

        return match;
    };

    isBothNumeric(val1, val2) {
        var n1 = this.isNumeric(val1);
        var n2 = this.isNumeric(val2);

        if (n1 !== n2) {
            throw new Error("Two variables in an expression have different type. " + val1 + " and " + val2 + " must be both either String values wrapped in '' or numeric");
        } else if (n1 && n2) {
            return true;
        } else {
            return false;
        }
    };

    doSubstitutionIfApplicable(value, attributes) {
        if (this.isVariable(value)) {
            return attributes[value.substring(1, value.length - 1)];
        }
        if (this.isString(value)) {
            return value.substring(1, value.length - 1);
        } else if (this.isNumeric(value)) {
            return value;
        } else {
            throw new Error("Invalid element declaration " + value + ". Should conform to Variable{" + value + "}; String '" + value + "' or be numeric");
        }

    };

    evaluateNumericExpression(keyValueStr, operand, valueStr) {
        var key = parseFloat(keyValueStr);
        var value = parseFloat(valueStr);

        if (operand == ">") {
            return key > value;
        } else if (operand == ">=") {
            return key >= value;
        } else if (operand == "<") {
            return key < value;
        } else if (operand == "<=") {
            return key <= value;
        } else if (operand == "=") {
            return key == value;
        } else if (operand == "!=") {
            return key != value;
        } else {
            throw new Error("Unknown operand: " + operand);
        }
    };

    evaluateStringExpression(value1, operand, value2) {
        if (operand == "=") {
            return value1 == value2;
        } else {
            throw new Error("Invalid operand for String matching (only = allowed): " + operand);
        }
    };

    isVariable(element) {
        return element.indexOf("{") == 0 && element.lastIndexOf("}") == (element.length - 1);
    };

    isString(element) {
        return element.charAt(0) == "'" && element.charAt(element.length - 1) == "'";
    };

    isNumeric(element) {
        return !isNaN(parseFloat(element)) && isFinite(element);
    }

}



// WEBPACK FOOTER //
// ./src/app/rules/RuleCalculator.ts